import { Grid } from "@mui/material";

import { PERIODS } from "../types";
import ItemButton from "./ItemButton";

export default function PeriodsControl() {
	return (
		<Grid
			container
			spacing={{ xs: 0.5, sm: 1 }}
			sx={{ p: { xs: 0.5, sm: 1 }, px: { xs: 2, sm: 3 } }}
		>
			{PERIODS.map((item) => (
				<Grid item key={item}>
					<ItemButton period={item} />
				</Grid>
			))}
		</Grid>
	);
}
